export interface LineInterface {
  type: 'row';
  index?: number;
  id?: string;
  entityId?: number;

  description: string;
  quantity: number;
  unitPrice: number;
  vatPct: number;
  taxTotal: number;
  netTotal: number;
  grossTotal: number;
  unit: string;
  currency?: string;
  focused?: boolean;
  dragOn?: boolean;
}
export const LineOrder: Array<keyof LineInterface> = [
  'description', 'quantity', 'unit', 'unitPrice', 'vatPct', 'taxTotal', 'netTotal', 'grossTotal'
];

export interface LineInterfaceWithId extends LineInterface {
  id: string;
}
